import { graphql } from '../../graphql/generated';

export const DOCTOR_SHEET_QUERY = graphql(`
  query DoctorSheet($doctorId: ID!) {
    doctorSheets(doctorId: $doctorId, withLabSheets: false) {
      id
      data
    }

    catalogParameters(doctorId: $doctorId) {
      id
      parameter {
        ...SheetEditor_Parameter
      }
    }

    doctor(id: $doctorId) {
      id
      flipParamNames
    }
  }
`);

export const SAVE_DOCTOR_SHEET_MUTATION = graphql(`
  mutation SaveDoctorSheet($doctorId: ID!, $input: SheetInput!) {
    saveDoctorSheet(doctorId: $doctorId, input: $input) {
      id
    }
  }
`);
